import formComponent from '@/util/proto/formComponent'

const result = [
  {value:1 , label:'通过'},
  {value:2 , label:'拒绝'},
  // {value:3 , label:'拒绝（车辆未达标）'},

]

const rejectReason = [
  {value:1 , label:'其他原因'},
  {value:2 , label:'车辆不达标'},
]
export default {
  extends: formComponent ,

  props:{
    data:{
      default(){
        return {}
      }
    },
    recheck:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      loading:false,
      state:{
        reviewResult:null,
        rejectReason:1,
        reviewDesc:null
      }
      // formData:{
      //   reviewResult: {
      //     rules:[
      //       { required: true, type:'number',message: '请选择审核结果', trigger: 'blur,change' },
      //     ]
      //   },
      //   reviewDesc: {
      //     rules:[
      //       { required: false, type:'number',message: '请填写拒绝理由', trigger: 'blur,change' },
      //     ]
      //   },
      // }
    }
  },
  created(){
    
  },
  methods:{
    save(){
      this.loading = true
      let params = {
        reviewResult:this.state.reviewResult,
        reviewDesc:this.state.reviewDesc,
        ...this.data
      }
      if( this.state.rejectReason == 2){
        params.reviewResult = 3
      }

      this.$request[this.recheck ? 'stdCarReviewMore' : 'stdCarReview'](params , this.recheck).then(resp => {
        this.loading = false
        
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.$Message.success('审核完成')
          this.$emit('ok')
        }
      })  
    },
    pass(){
      this.loading = 1
      this.save({id:this.id , reviewDesc:this.state.reviewDesc , reviewResult:1})
    },
    reject(){
      if( !this.state.reviewDesc ){
        this.$Message.error('请填写拒绝理由')
      }else{
        this.loading = 2
        this.save({id:this.id , reviewDesc:this.state.reviewDesc , reviewResult:2})
      }
    }
  },
  render(){
    const { loading , formData } = this
    let reviewResult = this.state.reviewResult;// ? this.form.getFieldValue('reviewResult') : null
    let extra
    if( reviewResult == 2 ){
      extra = [
          <sl-detail-list-item label="拒绝原因">
            <sl-select dict={rejectReason} type="radio" v-model={this.state.rejectReason} />
            <div style="margin-top:16px;">
              <Input type="textarea" placeholder="请描述细节" autosize={{ minRows: 2, maxRows: 6 }} v-model={this.state.reviewDesc} />
            </div>
          </sl-detail-list-item>
      ]
    }
    return (
      <div>
        <div class="modal-body">
          <sl-detail-list label-width={90} col={1}>
            <sl-detail-list-item label="审核结果">
              <sl-select dict={result} type="radio" v-model={this.state.reviewResult} />
            </sl-detail-list-item>
            {extra}
          </sl-detail-list>
        </div>
        <div class="modal-footer">
          <Button loading={loading} on-click={this.save} type="primary">确定</Button>
        </div>
      </div>
    )
    
  }
}